import Button from '_/ui/button'
import IconUse from '_/ui/icons/use'
import { Title } from '_/ui/title'
import Link from 'next/link'
import { tv, type VariantProps } from 'tailwind-variants'

const styles = tv({
	slots: {
		base: 'p-6 pt-8 pb-4 w-full border border-primary-light rounded-lg',
		title: 'text-gray-700 line-clamp-5 h-[7.313rem]',
		date: 'text-gray-200 text-sm flex items-center space-x-3 my-4',
	},
})

const { base, title, date } = styles()

export interface CardProps extends VariantProps<typeof styles> {
	className?: string
	excerpt: string
	createdDate: Date
	slug: string
	destinationSlug: string
	theme: string
}

export const Card = ({ className, excerpt, createdDate, slug, destinationSlug, theme, ...rest }: CardProps) => {
	const inputDate = new Date(createdDate)
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	const day = inputDate.getDate()
	const month = months[inputDate.getMonth()]
	const year = inputDate.getFullYear()
	const formattedDate = `${month} ${day}, ${year}`

	const href = `${process.env.NEXT_PUBLIC_SITE_URL}/${theme}/${destinationSlug}/guides/${slug}`

	return (
		<div className={`${base()} ${className}`} {...rest}>
			<Link href={href}>
				<Title size='small' className={title()} asChild>
					<h4>{excerpt.replace(/<[^>]*>?/gm, '').replace(/&amp;/g, '')}</h4>
				</Title>
			</Link>
			<div className={date()}>
				<IconUse id='calendar' width={16} height={16} fill='transparent' />
				<span>{formattedDate.toString()}</span>
			</div>
			<Button themeColor='secondary' asChild>
				<Link href={href}>Read More</Link>
			</Button>
		</div>
	)
}
